export { InvestmentBankingServicesPage as default } from "@nvb/ui";
